<template>
  <el-select
    v-loading="requestLoading"
    :value="value"
    @input="$emit('input', $event)"
    :multiple="multiple"
    :placeholder="placeholder"
    @change="changeHanlder"
    :style="{
      width: width,
    }"
  >
    <el-option
      v-for="item in specList"
      :key="item.id"
      :label="item.specName"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: "Fmerpv2WebCommoditySpecSelect",
  props: {
    value: {
      type: [[Array], String],
    },
    placeholder: {
      type: String,
      default: "请选择商品规格",
    },
    width: {
      type: [Number, String],
      default: "180px",
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    commodityId: {
      type: String,
    },
  },
  data() {
    return {
      requestLoading: true,
      specList: [],
    };
  },
  methods: {
    changeHanlder(val) {
      this.$emit("change", val);
    },
    async flush() {
      this.requestLoading = true;
      let requestRes = await this.$api.commodity_findById(this.commodityId);
      if (requestRes && requestRes.success) {
        this.specList = requestRes.data.commoditySpecList;
      }
      setTimeout(() => {
        this.requestLoading = false;
      }, 200);
    },
  },
  mounted() {
    this.flush();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/CommoditySpecSelect.vue